var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
/**
 * 给 class 添加全局前缀
 * @param atomic 原子类 class 名或者任意 class 名
 * @param localPrefix 组件传入的前缀
 */
export function addPrefix(atomic, localPrefix) {
    var globalPrefix = window.LegaoClassPrefix;
    // 优先使用组件内部定义的 class 前缀
    var prefix = localPrefix || globalPrefix;
    return prefix && atomic ? prefix + "-" + atomic : atomic;
}
export function addPrefixes(atomics, localPrefix) {
    var legaoClassNames = typeof atomics === 'string' ? [atomics] : atomics;
    return legaoClassNames.map(function (s) { return addPrefix(s, localPrefix); }).join(' ');
}
export function addComponentPrefix(name) {
    if (name.trim().indexOf(' ') > 0) {
        var nameArr = name.split(' ');
        var newArr = nameArr.reduce(function (pre, cur) {
            pre.push('legao-' + cur);
            return pre;
        }, []);
        return newArr.toString().replace(',', ' ');
    }
    return "legao-" + name;
}
// 自动给原子类添加前缀
export var AtomicTag = React.forwardRef(function (props, ref) {
    var atomics = props.atomics, prefix = props.prefix, children = props.children, tag = props.tag, autoPrefixedClassName = props.autoPrefixedClassName, cName = props.className, name = props.name, rest = __rest(props, ["atomics", "prefix", "children", "tag", "autoPrefixedClassName", "className", "name"]);
    var atomicClassNames = atomics ? addPrefixes(atomics, prefix) : '';
    var componentClassName = name ? addComponentPrefix(name) : '';
    var componentAutoPrefixedClassName = autoPrefixedClassName
        ? addComponentPrefix(autoPrefixedClassName)
        : '';
    var className = [componentClassName, cName, componentAutoPrefixedClassName, atomicClassNames]
        .filter(function (s) { return s !== ''; })
        .join(' ');
    return React.createElement(tag, __assign({ className: className, ref: ref }, rest), children);
});
// 快捷方式
export var DivTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ tag: "div", ref: ref }, props), props.children));
});
export var SectionTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ tag: "section", ref: ref }, props), props.children));
});
export var SpanTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ tag: "span", ref: ref }, props), props.children));
});
export var ATag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ tag: "a", ref: ref }, props), props.children));
});
export var AnchorTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ tag: "a", ref: ref }, props), props.children));
});
export var UlTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ tag: "ul", ref: ref }, props), props.children));
});
export var LiTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ tag: "li", ref: ref }, props), props.children));
});
export var ButtonTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "button" }, props), props.children));
});
export var TextAreaTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "textarea" }, props), props.children));
});
export var InputTag = React.forwardRef(function (props, ref) {
    return React.createElement(AtomicTag, __assign({ ref: ref, tag: "input" }, props));
});
export var LabelTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "label" }, props), props.children));
});
export var ImgTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "img" }, props), props.children));
});
export var SupTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "sup" }, props), props.children));
});
export var ITag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "i" }, props), props.children));
});
export var MainTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "main" }, props), props.children));
});
export var HeaderTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "header" }, props), props.children));
});
export var FooterTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "footer" }, props), props.children));
});
export var AsideTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "aside" }, props), props.children));
});
export var FormTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "form" }, props), props.children));
});
export var TableTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "table" }, props), props.children));
});
export var TrTag = React.forwardRef(function (props, ref) {
    return (React.createElement(AtomicTag, __assign({ ref: ref, tag: "tr" }, props), props.children));
});
